import { GrossMarginRequestDetail } from "@/services/gross-margin-requests.service"
import { Box, Text } from "@chakra-ui/react"

interface Props {
    detail: GrossMarginRequestDetail
}

export const ProducerObservation = ({ detail }: Props) => {

    return (
        <Box>
            <Text fontWeight={700} fontSize="16px" marginBottom="12px">
                Observación del productor
            </Text>
            <Box
                border="1px solid"
                borderColor="gray.200"
                borderRadius="6px"
                paddingX="16px"
                paddingY="12px"
                bg="gray.50"
            >
                <Text fontSize="14px">{detail.observacionProductor}</Text>
            </Box>
        </Box>
    )
}